import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SUPPORTED_UI_LANGUAGES, type UiLanguage } from '@/i18n';

const LANG_LABELS: Record<UiLanguage, string> = {
  fr: 'Français',
  en: 'English',
};

export function LanguageSwitcher(): JSX.Element {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage as UiLanguage) ?? 'fr';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={t('topbar.changeLanguage')}
          title={t('topbar.changeLanguage')}
        >
          <Languages className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {SUPPORTED_UI_LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l}
            onSelect={() => void i18n.changeLanguage(l)}
            className="cursor-pointer"
          >
            <span className="mr-2 w-6 text-xs uppercase text-muted-foreground">{l}</span>
            <span>{LANG_LABELS[l]}</span>
            {l === current ? <span className="ml-auto text-xs">✓</span> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
